import * as colors from '@mehilainen/mds-tokens/colors';
import { baseTypography } from '@mehilainen/mds-tokens/typography';
export const getThemeToggleButtons = (tokens) => {
    return {
        MuiToggleButton: {
            defaultProps: {
                size: 'medium',
            },
            styleOverrides: {
                root: () => ({
                    color: colors.Gray700,
                    fontSize: tokens.uiElementTypography.toggleButtonText,
                    fontWeight: baseTypography.weight.Regular,
                    lineHeight: baseTypography.height.Small,
                    backgroundColor: colors.White,
                    textTransform: 'none',
                    '&[class*="MuiToggleButton-sizeSmall"]': {
                        height: tokens.uiElementToggleButton.sizeSmall.height,
                        padding: tokens.uiElementToggleButton.sizeSmall.padding,
                        borderRadius: tokens.uiElementButton.sizeSmall.squareBorderRadius,
                    },
                    '&[class*="MuiToggleButton-sizeMedium"]': {
                        height: tokens.uiElementToggleButton.sizeMedium.height,
                        padding: tokens.uiElementToggleButton.sizeMedium.padding,
                        borderRadius: tokens.uiElementButton.sizeMedium.squareBorderRadius,
                    },
                    '&[class*="MuiToggleButton-sizeLarge"]': {
                        height: tokens.uiElementToggleButton.sizeLarge.height,
                        padding: tokens.uiElementToggleButton.sizeLarge.padding,
                        borderRadius: tokens.uiElementButton.sizeLarge.squareBorderRadius,
                    },
                    '&[class*="MuiButtonBase-root"][class*="MuiToggleButton-root"]': {
                        borderColor: colors.Gray400,
                    },
                    '&.Mui-selected, &.Mui-selected:hover': {
                        backgroundColor: colors.Primary500,
                        color: colors.White,
                    },
                    '&.Mui-disabled': {
                        color: colors.Gray500,
                        border: '1px solid ' + colors.Gray400,
                        backgroundColor: colors.Gray100,
                    },
                }),
            },
        },
    };
};
